// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"53":"mockups","524":"app"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".css";
};